
import MiniCartSlider from './MiniCartSlider.vue';
import { ProductHelpers } from '@/helpers/ProductHelpers.js';

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
    };
  },
  watch: {
    isOpen: {
      handler(val) {
        if (val && this.items.length === 0) {
          this.loadRecommendations();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async loadRecommendations() {
      if (!process.client) return;
      if (this.loading || this.items.length > 0) return;
      
      this.loading = true;
      const productHelpers = new ProductHelpers(this.$http, this);
      
      // We get the cart products from the store directly instead of a prop to be safer
      const cartProducts = this.$store.state.shop.cart.CartDetail?.Products;
      const lastItem = cartProducts?.[0];

      if (lastItem) {
        const permalink = String(lastItem.IdProduct);
        const idCart = this.$store.state.shop.cart.CartDetail?.IdCart || null;
        try {
          const response = await productHelpers.getProductstSimilar(
            permalink,
            idCart,
            'crosssell'
          );
          if (Array.isArray(response)) {
            this.items = response;
          }
        } catch (error) {
          console.error('[CartRecommendations] fetch error:', error);
        } finally {
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
    },
  },
  components: {
    MiniCartSlider,
  },
};
